import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- MICROFRONT - NEED-CONVERTER ------- */

export const needConverterRoutes = [
  {
    path: '/need-converter/:id?',
    name: 'need-converter',
    component: () => import('@b2ag/micro-front-need-converter/app'),
    meta: {
      private: true,
      storePathBeforeAuth: true,
      noMainPadding: true,
    },
    beforeEnter: (to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) => {
      const { id } = to.params
      if (!id) {
        next()
        return
      }
      const mongoObjectIdRegex = /^[0-9a-fA-F]{24}$/
      const isValidMongoObjectId = (value: string) => mongoObjectIdRegex.test(value)
      if (!isValidMongoObjectId(id as string)) {
        next({ name: 'not-found' })
      } else {
        next()
      }
    },
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'need-converter',
      viewName: 'default',
      id: route.params.id || null,
    }),
  },
]
